import posthog from 'posthog-js/dist/module.full.no-external'

import { logger } from '@/lib/observability/logger'

let analyticsSessionId: string | undefined

function register(sessionId: string) {
  try {
    posthog.register_for_session({ session_id: sessionId })
  } catch {
    logger.warn('Failed to register analytics session id')
  }
}

/**
 * Stores the server-minted `mo-session-id` and registers it as the PostHog
 * `session_id` session property, so every event and replay can be joined with
 * the BetterStack log lines stamped with the same `sessionId`. It is
 * session-scoped (not persisted to localStorage) so a fresh browser session
 * never inherits the previous session's id.
 */
export function setAnalyticsSessionId(sessionId: string) {
  analyticsSessionId = sessionId
  register(sessionId)
}

/**
 * Re-registers the stored session id, if any. `posthog.reset()` wipes super
 * properties, so this runs from `registerSessionProperties()` after every
 * reset.
 */
export function registerAnalyticsSessionId() {
  if (analyticsSessionId) register(analyticsSessionId)
}
